export const RATE_NAME = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
  ADVANCED_YEAR: 'advancedAnnual',
  BASIC_YEAR: 'basicAnnual',
  ADVANCED_TRIAL: 'advancedTrial',
  PLO4: 'plo4',
  PLO5: 'plo5',
  PLO4PLO5: 'plo4plo5',
  PLO4_YEAR: 'plo4annual',
  PLO5_YEAR: 'plo5annual',
  PLO4PLO5_YEAR: 'plo4plo5annual',
};

const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');

export const PRICE_KEY = {
  BASIC: isDev ? 'price_1IB0NwIHRoT06REwsrBpm221' : 'price_1ICmorIHRoT06REwqsz0FZHL',
  ADVANCED: isDev ? 'price_1IB0OXIHRoT06REw0bcHWAXs' : 'price_1ICmoTIHRoT06REw6QJS3M9V',
  ADVANCED_YEAR: isDev ? 'price_1JUZQMIHRoT06REwbw7mkDjR' : 'price_1JX0HsIHRoT06REw16279XZr',
  BASIC_YEAR: isDev ? 'price_1JUZRGIHRoT06REwvdAQqU5l' : 'price_1JX0GxIHRoT06REwzcOXLK5d',
  ADVANCED_TRIAL: isDev ? 'price_1JX00qIHRoT06REwMNtbQbAW' : 'price_1JX0IFIHRoT06REwQFdYHeAq',
  PLO4: isDev ? 'price_1NPKnvIHRoT06REwitP2F5Aj' : 'price_1NYViHIHRoT06REwsuDI6Hj7',
  PLO5: isDev ? 'price_1NPKp9IHRoT06REwgTThmZJV' : 'price_1NYViPIHRoT06REwjtjJ2nUr',
  PLO4PLO5: isDev ? 'price_1NPKq3IHRoT06REw3sRJ3e3L' : 'price_1NYViWIHRoT06REwlw9yCA39',
  PLO4_YEAR: isDev ? 'price_1NOiqyIHRoT06REwUHQBOPjK' : 'price_1NYViHIHRoT06REwqDhydOLR',
  PLO5_YEAR: isDev ? 'price_1NPKozIHRoT06REwOYwAoHJl' : 'price_1NYViPIHRoT06REw2KfKiksL',
  PLO4PLO5_YEAR: isDev ? 'price_1NSO0zIHRoT06REwltdw6WVC' : 'price_1NYViWIHRoT06REwN907qIgQ',
};

// KEY
// export const PRICE_KEY = {
//   BASIC: 'price_1ICmorIHRoT06REwqsz0FZHL',
//   ADVANCED: 'price_1ICmoTIHRoT06REw6QJS3M9V',
//   ADVANCED_YEAR: 'price_1JX0HsIHRoT06REw16279XZr',
//   BASIC_YEAR: 'price_1JX0GxIHRoT06REwzcOXLK5d',
//   ADVANCED_TRIAL: 'price_1JX0IFIHRoT06REwQFdYHeAq',
// };
